import { IconUser16 } from '@warp-ds/icons/react';

import { FrontpageModal } from '../common/FrontpageModal';
import { CustomNumberInput } from '../common/CustomNumberInput';
import { Dropdown } from '../common/Dropdown';

export const BEDROOM_KEY = 'no_of_bedrooms_from';
export const BED_KEY = 'no_of_beds_from';

type BedroomFilterProps = {
    filters: { [BEDROOM_KEY]?: number; [BED_KEY]?: number };
    onFilterChanged: (val: Record<string, number>) => void;
    trigger?: {
        text: string;
        label?: string;
    };
};

export const BedroomFilter = ({ filters, onFilterChanged, trigger }: BedroomFilterProps) => {
    const bedroomValue = filters[BEDROOM_KEY] || 0;
    const bedValue = filters[BED_KEY] || 0;

    const inputs = [
        {
            id: BED_KEY,
            value: bedValue,
            label: 'Gjester',
            setNumber: (val: number) => onFilterChanged({ [BED_KEY]: val }),
            min: 0,
            max: 20,
            disableAdd: false,
            disableSubtract: bedValue <= 0,
        },
        {
            id: BEDROOM_KEY,
            value: bedroomValue,
            label: 'Soverom',
            helpText: 'Minimum antall',
            setNumber: (val: number) => onFilterChanged({ [BEDROOM_KEY]: val }),
            min: 0,
            max: 20,
            disableAdd: false,
            disableSubtract: bedroomValue <= 0,
        },
    ];

    return (
        <>
            <FrontpageModal
                breakpoint="sm"
                title="Gjester og soverom"
                trigger={{
                    text: trigger?.text ?? '',
                    prefix: <IconUser16 aria-hidden />,
                    aria: {
                        label: 'endre soverom og gjester',
                    },
                }}>
                {inputs.map((input) => (
                    <CustomNumberInput key={input.id} {...input} />
                ))}
            </FrontpageModal>
            <Dropdown
                className="hidden sm:flex"
                trigger={{
                    text: trigger?.text ?? '',
                    label: 'Reisende',
                }}
                prefix={<IconUser16 aria-hidden />}>
                {inputs.map((input) => (
                    <CustomNumberInput key={input.id} {...input} />
                ))}
            </Dropdown>
        </>
    );
};
